/** Session-scoped storage for president invite codes (plaintext shown once from API). */

const STORAGE_PREFIX = 'yona:club-invite-code:';

function getSessionStorage() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function inviteCodeStorageKey(clubId) {
  return `${STORAGE_PREFIX}${clubId}`;
}

export function saveStoredInviteCode(clubId, { code, expiresAt }) {
  const storage = getSessionStorage();
  if (!storage || clubId == null || !code) return;
  try {
    storage.setItem(
      inviteCodeStorageKey(clubId),
      JSON.stringify({ code, expiresAt: expiresAt || null, savedAt: Date.now() })
    );
  } catch {
    /* no-op */
  }
}

export function loadStoredInviteCode(clubId) {
  const storage = getSessionStorage();
  if (!storage || clubId == null) return null;
  try {
    const raw = storage.getItem(inviteCodeStorageKey(clubId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.code) return null;
    if (parsed.expiresAt && new Date(parsed.expiresAt) <= new Date()) {
      clearStoredInviteCode(clubId);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearStoredInviteCode(clubId) {
  const storage = getSessionStorage();
  if (!storage || clubId == null) return;
  try {
    storage.removeItem(inviteCodeStorageKey(clubId));
  } catch {
    /* no-op */
  }
}
